import gsap, { TweenLite } from 'gsap';
import * as PIXI from 'pixi.js';
import { AwardOptionPosition, ExtendedSpinAndHoldEndAction, PlayWindow, ScatterRandomAwardResult, SimpleSlotGameState, SpinAndHoldCommonConfiguration, SpinAndHoldSpinAction, SpinAndHoldStartAction, UnlockRowsConfig, UnlockRowsResult } from "../../../api";
import { ITimeout } from "../../../Context/Timeout";
import { assertEqual, assertNotMore, assertNotNullish } from "../../../debug";
import { CreateElement, Filter, FilterFeatures, IsEmptyOrNull, Log, Point, Rect, Safe, Scale, SetStyles, Size, TranslateScreen1To1 } from "../../../MyHelpers";
import { Resourceful2 } from "../../../ResourceManager/Resourceful";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage } from "../../../ResourceManager/ResourceManager";
import { SpriteResource } from "../../../ResourceManager/SpriteResource";
import { service } from "../../../services";
import { Settings } from "../../../Settings";
import { ParseMonitors } from "../../../system/ParseMonitors";
import { ZIndex } from "../../../ZIndex";
import { IBonusStartConfig } from "../../SlotGame";
import { S2_SpinnableReelsBigCanvas2 } from "../../SpinAnimation2/SpinnableReelsBigCanvas2";
import { ConstructReelsParams } from "../SlotBonus";
import { HoldingFeatureParamsPIXI, HoldingFeaturePIXIApp } from "../SpinAndHold/HoldingFeaturePIXIApp";
import { SpinAndHoldParams } from "../SpinAndHold/SpinAndHoldParams";
import { SpinAndHoldBonusPIXIAPP } from "../SpinAndHold/SpinAndHoldPIXIAPP";
import { SpinAndHoldState } from "../SpinAndHold/SpinAndHoldState";
import { ExtededSpinAndHoldBonusGameState } from "./ExtendedSpinAndHold";
import { IUnlockFeatureParams } from "./UnlockFeature";
import { UnlockFeaturePIXIAPP } from "./UnlockFeaturePIXIAPP";


export class ExtendedSpinAndHoldPIXIApp extends SpinAndHoldBonusPIXIAPP implements Resourceful2 {
	public override OnResize(): void {
		throw new Error('Method not implemented.');
	}
	protected unlockFeature: UnlockFeaturePIXIAPP;
	protected windowRectangle: Rect;	
	protected override BonusName(): string {
		return "ExtendedSpinAndHold";
	}
	//protected animBottomToTopWinContainer :  gsap.core.Tween = null;
	protected timeoutCometShowtime : ITimeout = null;
	protected isMovedWincontainer: boolean = false;
	public constructor(gameName: string, params: SpinAndHoldParams, config: SpinAndHoldCommonConfiguration) {
		super(gameName, params, config);	
		this.view.style.height = Scale.Hpx((1080 * Settings.Screens));
		this.view.style.width = Scale.Wpx(1920);
		this.view.style.top = Scale.Ypx(-2160);
		this.view.style.position = "absolute";
		this.timeoutCometShowtime = this.systemContext.TimingContext().CreateTimeout("timeoutCometShowtime", 1000, () => { this.CometShowtime(this.scatterPositions[this.currentScatterCometIndex])});
		// this.animBottomToTopWinContainer = 	gsap.to(this.bonunsGameAwardViewPIXIAPP
		// 	, {duration: 1,
		// 	y: Scale.Y(-58),
		// }).pause();
	}

	public override async PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {
		await super.PrepareResources(loadingStage, resourceManager);

		if (loadingStage != LoadingStage.Games) return;
		
		resourceManager.Add(new SpriteResource(this.params.commonBonusResourcesBasePath + "resources/BonusTitle", this.resid.Add("bonusTitleExtendedSpinAndHold"), true, this.logGroup.Add("bonusTitleExtendedSpinAndHold"), true));
		resourceManager.Add(new SpriteResource(this.params.commonBonusResourcesBasePath + `resources/FramesWinSpine/${Settings.JackpotDisplayType}/frameSpriteWin`, this.resid.Add("frameSpriteExtendedSpinAndHold"), true, this.logGroup.Add("frameSpriteExtendedSpinAndHold"), true));
		
		
	}

	public override async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
		await super.ResourcesLoaded(loadingStage, resourceManager);
			if (loadingStage != LoadingStage.Games) return;
	}

	
	protected gameState: ExtededSpinAndHoldBonusGameState;
	
	protected override async FeaturesPrepare(resourceManager: IWriteOnlyResourceManager): Promise<void> {
		await super.FeaturesPrepare(resourceManager);
		

		const unlockRowsConfig = FilterFeatures(this.config.MultiFeatureConfiguration, (f): f is UnlockRowsConfig => f.FeatureType == "UnlockRows");
		if (!IsEmptyOrNull(unlockRowsConfig))
		{
			let params: IUnlockFeatureParams =
			{
				resid: this.resid,
				translator: this.translator,
				systemContext: this.systemContext,
				gameBonusResourcesBasePath: this.params.gameBonusResourcesBasePath,
				commonBonusResourcesBasePath: this.params.commonBonusResourcesBasePath,
				audio: this.audio,
				gameName: this.gameName,
				aspectFixY: ParseMonitors().AspectFixY,
				spinnableReels2: this.spinnableReels2,
				windowRectangle: this.windowRectangle
			}


			this.unlockFeature = new UnlockFeaturePIXIAPP(params, unlockRowsConfig,this.params.symbolCollection);
		}

		if (this.unlockFeature)
		{
			await this.unlockFeature.PrepareResources(resourceManager);
		}
	}

	protected override async HoldingFeaturePrepare(resourceManager: IWriteOnlyResourceManager){
		let params: HoldingFeatureParamsPIXI = 
		{
			logGroup: this.logGroup,
			resid: this.resid,
			spinnableReels: this.spinnableReels2,
			gameResourcesBasePath: this.params.gameBonusResourcesBasePath,
			reelsCoverAnotherScreen : true,
			gameName : this.gameName,
			symbolCollection : this.params.symbolCollection,
			symbolTypeAnim : this.params.gameConfig.symbolsType,
			audio : this.audio,
		};

		this.holdingFeature = new HoldingFeaturePIXIApp(params);
		await this.holdingFeature.PrepareResources(resourceManager);
		this.holdingFeature.holdingFeatureEndCallback=()=>{
			this.NextScatterMultiplier();
		}		
	}

	protected override async FeaturesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
		await super.FeaturesLoaded(resourceManager);
		
		if (this.unlockFeature)
		{
			await this.unlockFeature.ResourcesLoaded(resourceManager);			
		}
	}

	protected override ConstructReelParams(constructReelsParams: ConstructReelsParams) {	

			
		assertNotNullish(constructReelsParams.ReelSet, "ReelSet must be set when constructing reels");

		if (this.spinnableReels2)
		{
			this.spinnableReels2.Destroy();
		}

		this.spinnableReels2 = new S2_SpinnableReelsBigCanvas2(
			this.resid,
			{
				reelConfig: constructReelsParams.ReelSet,
				playWindow: constructReelsParams.PlayWindow
			},
			{
				windowRect: constructReelsParams.WindowRect,
				leftBorderWidth: this.params.spinnableReelsParams.leftBorderWidth,
				rightBorderWidth: this.params.spinnableReelsParams.rightBorderWidth,
				topBorderWidth: this.params.spinnableReelsParams.topBorderWidth,
				bottomBorderWidth: this.params.spinnableReelsParams.bottomBorderWidth,
				backgroundImage : this.params.spinnableReelsParams.backgroundImage,
				
				pixiSpritesByName : this.params.pixiSpritesByName,

			},
			this.systemContext,
			constructReelsParams.Extended
		);

		this.spinnableReels2.OnCreatedCallback = () => {
			this.ReelBackgroundLoaded();
			//this.redrawPixiReels();
		};
	}

	protected override ConstructReels2(constructReelsParams: ConstructReelsParams) {
		super.ConstructReels2(constructReelsParams);

		//const unlockRowsConfig: UnlockRowsConfig = this.config.FeatureConfiguration["UnlockRows"];
		// const unlockRowsConfig = FilterFeatures(this.config.MultiFeatureConfiguration, (f): f is UnlockRowsConfig => f.FeatureType == "UnlockRows");
		// if (!IsEmptyOrNull(unlockRowsConfig))
		// {
		// 	this.unlockFeature.Construct(this.spinnableReels2, unlockRowsConfig);
		// }
	}
	
	protected oldDisplayed: number;
	protected override OnFeaturesBegin(): void {
		super.OnFeaturesBegin();
		let ScatterRandomAward = this.simpleLastBonusAction.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult
		if (ScatterRandomAward.ScattersAddedThisSpin > 0) {
			this.gameState = ExtededSpinAndHoldBonusGameState.SpinsRemaining;
			this.ChangeStateCanvas(this.gameState, this.session.RunsRemaining);
			ScatterRandomAward = null;
		}
		let unlockRowsSimpleLastAction = this.simpleLastBonusAction.SpinWithFeatures.FeatureResults["UnlockRows"] as UnlockRowsResult
		this.unlockFeature.UpdateSraUnlock(unlockRowsSimpleLastAction);
	}

	public override Start(): void {
		super.Start();
		//this.animWinCount.restart();
		//this.animWinCount.pause();		
		//this.winContainer.style.display = "none";
		//this.WinValue = 0;
		//this.DrawTextCanvas("?", this.winCountCanvas, this.infoHeightWinCount);
		this.unlockFeature.RestartAnim();
		this.unlockFeature.StartAnim();
		this.gameState = ExtededSpinAndHoldBonusGameState.SpinsRemaining;
		this.ChangeStateCanvas(ExtededSpinAndHoldBonusGameState.SpinsRemaining, this.session.RunsRemaining);
		//this.indexsimpleLastSpinAction = 0;
		//this.animBottomToTopWinContainer.restart();
		//this.animBottomToTopWinContainer.pause();
	}

	protected isWinContainerShowWinMovedJumped = false;
	public override Prepare(startConfig: IBonusStartConfig) {
		super.Prepare(startConfig);

		let simplestartConfig = startConfig.actions as SpinAndHoldStartAction[];
		let startConfigExtended = simplestartConfig.find(b => b.Phase == "Start");
		if (startConfigExtended) {
			let scatterStartConfig = startConfigExtended.SpinWithFeatures.FeatureResults["UnlockRows"] as unknown as UnlockRowsResult
			this.unlockFeature.Start(scatterStartConfig);
			simplestartConfig = null;
			scatterStartConfig = null;
		};
		this.isMovedWincontainer = false;
		this.isWinContainerShowWinMovedJumped = false;
	}

	protected override DestinationComet(): Point {

		// protected override DesinationComet(): Point {		
		// 	let destination: Point = TranslateScreen1To1(new PixelRect(0, Scale.W(1080), Scale.W(1920), Scale.H(1080))).Center();
		// 	//change position for bottom because win container its move from bottom to top when sra comets its display
		// 	if (this.scatterPositions[this.currentScatterCometIndex].AwardOptionPosition.Row < this.spinnableReels2.GetWindowSymbolSize().height / 2) {								
		// 		destination = TranslateScreen1To1(new PixelRect(0, Scale.W(2200), Scale.W(1920), Scale.H(1080))).Center();
		// 	}
		// 	return destination 
		// }

		// 2 screen config
		if (Settings.Screens == 2)
		{
			if (this.scatterPositions[this.currentScatterCometIndex].AwardOptionPosition.Row < this.spinnableReels2.GetWindowSymbolSize().Height / 2) {								
				// where the win is on the bottom
				return TranslateScreen1To1(new Rect(Scale.X(0), Scale.Y(2200 - 1080), Scale.W(1920), Scale.H(1080))).Center();
			}
			else
			{
				// where the win is on the top
				return TranslateScreen1To1(new Rect(Scale.X(0), Scale.W(1080 - 1080), Scale.W(1920), Scale.H(1080))).Center();
			}
		}

		// or 3 screen with 2+1 enabled, that behaves like 2 screen
		
		else (Settings.Screens == 3)
		{
			if (Settings.Enable2plus1)
			{
				if (this.scatterPositions[this.currentScatterCometIndex].AwardOptionPosition.Row < this.spinnableReels2.GetWindowSymbolSize().Height / 2)
				{								
					// where the win is on the bottom
					return TranslateScreen1To1(new Rect(Scale.X(0), Scale.Y(1080 + 1080), Scale.W(1920), Scale.H(1080))).Center();
				}
				else
				{
					// where the win is on the top
					return TranslateScreen1To1(new Rect(Scale.X(0), Scale.Y(1080), Scale.W(1920), Scale.H(1080))).Center();
				}
			}
			else
			{
				return TranslateScreen1To1(new Rect(0, 50, Scale.W(1920), Scale.H(1080))).Center();
			}
		}

		// normal 3 screen with win on 3. screen
		if (Settings.Screens == 3)
		{
			
		}

		throw new Error(`DesinationComet not implemented for ${Settings.Screens}`);
		return null;
	}
	

	public override Update(): void {
		super.Update();
		//this.frameSprite.Update();
		//this.bonusWinSprite.Update();
		this.unlockFeature?.Update();

		//Redraw Canvas Info Stats
		// if (this.remainingSpinsCanvas.WasContextLost) {
		// 	this.ChangeStateCanvas(this.gameState, this.session.RunsRemaining);
		// }
		// if (this.winCountCanvas.WasContextLost) {
		// 	this.DrawTextCanvas(service.moneyFormatter.FormatCurrency(this.WinValue), this.winCountCanvas, this.infoHeightWinCount);
		// }
	}

	protected override OnSpinIdleBegin(): void {
		super.OnSpinIdleBegin();


		if (this.session.RunsRemaining < 1) {
			this.gameState = ExtededSpinAndHoldBonusGameState.WinCount;
			this.ChangeStateCanvas(this.gameState);			
		}
	}

	protected override OnCometCollectBegin(): void {
		super.OnCometCollectBegin();
		//this.WinCountShow();
	 }

	 protected override WinCountShow() {	
		super.WinCountShow();
		//change position for winContainer 
		this.SetPositionAwardContainer()	
		

		if (globalThis.jackpotDisplayGlobal != null) {
			TweenLite.to(globalThis.jackpotDisplayGlobal.View(), 0.8, {
				alpha: 0
			});
		}
	}

	protected SetPositionAwardContainer() {

		this.bonusGameAwardViewPIXIAPP.position.y = Scale.Y(0);
		if (Settings.Screens == 3 && Settings.Enable2plus1 == false) return;

		if (this.scatterPositions[0].AwardOptionPosition.Row >= this.spinnableReels2.GetWindowSymbolSize().Height / 2) {
			//top position
			this.bonusGameAwardViewPIXIAPP.position.y = Scale.Y(-58);
			if(Settings.Enable2plus1 == true )this.bonusGameAwardViewPIXIAPP.position.y = Scale.Y(1085);
			this.isMovedWincontainer = false;
		} else {
			//bottom postion
			this.bonusGameAwardViewPIXIAPP.position.y = Scale.Y(908);
			if(Settings.Enable2plus1 == true )this.bonusGameAwardViewPIXIAPP.position.y = Scale.Y(1988);
			this.isMovedWincontainer = true;
		}
	}
	
	protected override InternalNextComet() {
		//this.isShowed = true;
		this.currentScatterCometIndex++;
		if (this.currentScatterCometIndex >= this.scatterPositions.length) {
			// Log.Debug(this.logGroup, "Comets complete");			
			this.panel.SetWin(service.moneyFormatter.FormatCreditCurrentDenom(this.startAction.WinSinceGameStart.TotalWin.InCents), service.moneyFormatter.FormatCurrency(this.startAction.WinSinceGameStart.TotalWin.InCents))
			this.timeoutFinalMessageState.Start();
		}
		else {
			if (SpinAndHoldState.CometCollect == this.stateMachine.State()) {
				this.isShowed = false;
				if ((this.scatterPositions[this.currentScatterCometIndex].AwardOptionPosition.Row >= this.spinnableReels2.GetWindowSymbolSize().Height / 2) && this.isMovedWincontainer == true) {
					//this.animBottomToTopWinContainer.restart();
					let yPosition = Scale.Y(-58)
					if (Settings.Enable2plus1 == true) yPosition = Scale.Y(1085);
					gsap.to(this.bonusGameAwardViewPIXIAPP
						, {
							duration: 1,
							y: yPosition,
						});

					//its moved need turn of flag for dont move all time
					this.isMovedWincontainer = false;
					//add some delay for wait move container and later show comet anim
					this.timeoutCometShowtime.Start();
					//setTimeout(() => { this.CometShowtime(this.scatterPositions[this.currentScatterCometIndex]); }, 1000)
				} else {
					//jumps to cometshowTime dosent need add delay here
					this.CometShowtime(this.scatterPositions[this.currentScatterCometIndex]);
				}
			}
		}
	}

	

	protected override OnSpinBegin(): void {
		this.session.RunsRemaining--;
		this.session.RunsPlayed++;
		this.audio.Play(this.parentresid.ScopedResourceName("leverpull"));
		if (this.session.RunsRemaining >= 1) {
			this.gameState = ExtededSpinAndHoldBonusGameState.SpinsRemaining;
			this.ChangeStateCanvas(this.gameState, this.session.RunsRemaining);
		}
		else {
			this.gameState = ExtededSpinAndHoldBonusGameState.LastSpin;
			this.ChangeStateCanvas(this.gameState);
		}
		this.OnSimpleSpinRunResult();
	}

	protected override OnIntroMessageBegin(): void {		
		this.PanelRequired(true);
		this.robotPlay.BonusConfirm("IntroMessage");
		this.unlockFeature.StartAnim();
	}


	public ChangeStateCanvas(state: ExtededSpinAndHoldBonusGameState, runRemaining: number = 0) {
		switch (state) {
			case ExtededSpinAndHoldBonusGameState.SpinsRemaining:				
				this.infoRemainingSpinsTextPIXIAPP.text = this.translator.t.extendendDiamondSpinRemaining(runRemaining);
				break;
			case ExtededSpinAndHoldBonusGameState.LastSpin:				
				this.infoRemainingSpinsTextPIXIAPP.text = this.translator.t.extendendLasSpinMessage;
				break;
			case ExtededSpinAndHoldBonusGameState.WinCount:				
				this.infoRemainingSpinsTextPIXIAPP.text = this.translator.t.goodluck;
				break;
		}
	}

	// public override async PrepareTransition(resourceManager: IWriteOnlyResourceManager) {

	// 	let pathTrack: string;
	// 	let pathSprite: string;
	// 	let pathVideo: string;
	// 	if (Settings.JackpotDisplayType != JackpotDisplayType.PaytableJackpotDisplay) {

	// 		let pathTrack = this.params.commonBonusResourcesBasePath + "resources/VideosBackgroundResources-Transition/" + Settings.JackpotDisplayType + "/tracks/" + Settings.JackpotDisplayType + Settings.audioFormat;
	// 		let pathSprite = this.params.commonBonusResourcesBasePath + "resources/VideosBackgroundResources-Transition/" + Settings.JackpotDisplayType + "/" + Settings.JackpotDisplayType + "_Transition";
	// 		let pathVideo = this.params.commonBonusResourcesBasePath + "resources/VideosBackgroundResources-Transition/" + Settings.JackpotDisplayType + "/Background_" + Settings.Screens + "S";
	// 		//Overwrite this video path because for this jackpots need different 
	// 		if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPot || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotOrtiz || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotStep || Settings.JackpotDisplayType == JackpotDisplayType.DragonJackpot || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotRappidFrames) {
	// 			pathVideo = Settings.ResourcesFolder + "multigame/slot/" + this.gameName + "/resources/video/presentation_" + Settings.Screens + "s";
	// 			//pathTrack  = this.params.commonpath + "resources/HoldAndSpin/resources/VideosBackgroundResources-Transition/" + Settings.JackpotDisplayType + "/tracks/DiamondPot" + Settings.audioFormat;
	// 		}

	// 		if(globalThis.jackpotDisplayGlobal.GetSpineSkeleton() == null)  resourceManager.AddGlobal(new SpriteResource(pathSprite, ResourceIdentifier.Global.Add("TitleTransition").Add(this.bonusName), true, LogGroup.Global.Add("TitleTransition").Add(this.bonusName), true))
	// 		this.audio.AddTrack(new Track(pathTrack, this.resid.ScopedResourceName("VoiceJackpotType")));

	// 		if (Settings.PresentationType == Presentation.VideoGameSprite) {
	// 			resourceManager.AddGlobal(new VideoResource2({
	// 				resid: ResourceIdentifier.Global.Add(this.gameName + "-" + this.bonusName + "-Transition-" + Settings.Screens),
	// 				logGroup: LogGroup.Global.Add(this.gameName + "-" + this.bonusName + "-Transition-" + Settings.Screens),
	// 				src: pathVideo,
	// 				unloadOnHide: true
	// 			}));
	// 		}
	// 		else if (Settings.PresentationType == Presentation.VideoCommonNoSprite) {
	// 			pathVideo = this.params.commonBonusResourcesBasePath + "resources/VideosBackgroundResources-Transition/" + Settings.JackpotDisplayType + "/BackgroundVideoSprite_" + Settings.Screens + "S";
	// 			resourceManager.AddGlobal(new VideoResource2({
	// 				resid: ResourceIdentifier.Global.Add(this.gameName + "-" + this.bonusName + "-Transition-" + Settings.Screens),
	// 				logGroup: LogGroup.Global.Add(this.gameName + "-" + this.bonusName + "-Transition-" + Settings.Screens),
	// 				src: pathVideo,
	// 				unloadOnHide: true
	// 			}));
	// 		}
	// 		else if (Settings.PresentationType == Presentation.Image) {
	// 			let pathImgTransition = this.params.commonBonusResourcesBasePath + "resources/VideosBackgroundResources-Transition/" + Settings.JackpotDisplayType + "/BackgroundTransition_" + Settings.Screens + "S.png";
	// 			if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPot || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotOrtiz || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotStep) {
	// 				pathImgTransition = `${this.params.gamepath}resources/BackgroundTransition_${Settings.Screens}S.png`;
	// 			}
	// 			resourceManager.AddGlobal(new ImageResource(pathImgTransition,
	// 				ResourceIdentifier.Global.Add(this.gameName + "-" + this.bonusName + "-BackgroundTransition-" + Settings.Screens).Scope()));
	// 			//debugger
	// 		}
	// 		else if (Settings.PresentationType == Presentation.VideoCommonClassic) {
	// 			pathVideo = this.params.commonBonusResourcesBasePath + "resources/VideosBackgroundResources-Transition/" + Settings.JackpotDisplayType + "/BackgroundCommonVideo_" + Settings.Screens + "S";
	// 			resourceManager.AddGlobal(new VideoResource2({
	// 				resid: ResourceIdentifier.Global.Add(this.bonusName + "-Transition-" + Settings.Screens),
	// 				logGroup: LogGroup.Global.Add(this.bonusName + "-Transition-" + Settings.Screens),
	// 				src: pathVideo,
	// 				unloadOnHide: true
	// 			}));
	// 		}
	// 		else if (Settings.PresentationType == Presentation.VideoParticleTransitionMatterJS) {
	// 			resourceManager.Add(new PixiSpriteResource(Settings.ResourcesFolder + `multigame/slot/${this.gameName}/resources/FillingPotFeature/symbolFillingPotPartitle-Transition`, this.resid.Add("Partitle-Transition").Shared(), true, this.logGroup.Add("Partitle-Transition"), true));
	// 			// resourceManager.AddGlobal(new JSONResource(Settings.ResourcesFolder + `multigame/slot/${this.gameName}/resources/FillingPotFeature/partitleTransitionBoundingBox.json`,
	// 			// ResourceIdentifier.Global.Add(this.gameName + "-" +this.bonusName + "-partitleTransitionBoundingBox").Shared().CSSScope(),true));
	// 		}
	// 		else if (Settings.PresentationType == Presentation.VideoParticleTransitionFadeInFadeOut) {
	// 			resourceManager.Add(new PixiSpriteResource(Settings.ResourcesFolder + `multigame/slot/${this.gameName}/resources/FillingPotFeature/symbolFillingPotPartitle-Transition`, this.resid.Add("Partitle-Transition").Shared(), true, this.logGroup.Add("Partitle-Transition"), true));
	// 			// resourceManager.AddGlobal(new JSONResource(Settings.ResourcesFolder + `multigame/slot/${this.gameName}/resources/FillingPotFeature/partitleTransitionBoundingBox.json`,
	// 			// ResourceIdentifier.Global.Add(this.gameName + "-" +this.bonusName + "-partitleTransitionBoundingBox").Shared().CSSScope(),true));
	// 		}
	// 		pathTrack = null;
	// 		pathSprite = null;
	// 		pathVideo = null;
	// 	}
	// }

	// // //LOAD FOR TRANSITION 
	public override async TransitionLoaded(resourceManager: IReadOnlyResourceManager) {
		await super.TransitionLoaded(resourceManager);
		this.transitionView.onTransitionStart = () => {
			this.OnTransitionStarted();
			if (globalThis.jackpotDisplayGlobal && Settings.Screens == 2 || globalThis.jackpotDisplayGlobal && Settings.Enable2plus1 == true) {
				TweenLite.to(globalThis.jackpotDisplayGlobal.View(), 0.2, {
					alpha: 0
				});
			}
		}
	}

	protected override EnableFadeOutVideo(): boolean {
		return false;
	}

	protected override OnFinalMessageEnd(): void {
		super.OnFinalMessageEnd()
		// if (globalThis.jackpotDisplayGlobal != null) {
		// 	globalThis.jackpotDisplayGlobal.View().style.opacity = "1";
		// }
	}

	public override HistoryView(actionIndex: number, gameState: SimpleSlotGameState): HTMLElement {
		//let gameState: SimpleSlotGameState = JSON.parse(entry2.HistoryGameState.GameState);
		const spin: SpinAndHoldSpinAction = gameState.Actions[actionIndex] as SpinAndHoldSpinAction;
		const actionsToCheck = gameState.Actions.slice(1, actionIndex +1);
	
		const start: SpinAndHoldStartAction = [...actionsToCheck].reverse().find(a => a.Phase == "Start") as SpinAndHoldStartAction; 		
		const playWindow: PlayWindow = start.PlayWindow;

		const reelSet = this.config.MultiReelSets[start.ReelSetId];
		assertNotNullish(reelSet, "ReelSet must be defined");

		let bonusView: HTMLElement = CreateElement("div", {
			classes: ["bonusView", "SpinAndHoldHistory"],
			style:
			{
				width: "100%",
				height: "100%",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				flexDirection: "column",
			}
		});

		const bonusMultiplier = spin.Multiplier || 1;

		CreateElement("h2", {
			classes: ["ui", "inverted", "dividing", "center", "aligned", "header"],
			parentToAppend: bonusView,
			innerHTML: "MULTIPLIER: x" + bonusMultiplier.toString(),
		});

		let reelView: HTMLElement = null;
		let gameView: HTMLElement = CreateElement("div", {
			classes: ["gameBackground"], parentToAppend: bonusView,
			style:
			{
				width: Scale.Wpx(900),
				height: Scale.Hpx(700),
				backgroundRepeat: "no-repeat",
				backgroundSize: "cover",
				backgroundPosition: "center",
				display: "flex",
				flexDirection: "row",
				justifyContent: "center",
				alignItems: "center",
				backgroundImage: this.gameBackground,
			}
		});

		if (spin.Phase == "Start" || spin.Phase == "Spin") {
			console.log(`Scatter positions`, (spin.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult).ScattersPosition);
			// reel view
			reelView = CreateElement("div", {
				classes: ["reelView"], parentToAppend: gameView,
				style:
				{
					width: Scale.Wpx(900),
					height: Scale.Hpx(700),
				}
			});


			let reelTable: HTMLElement = CreateElement("table", { classes: ["reelTable"], parentToAppend: reelView, style: { width: "100%", height: "100%", borderCollapse: "collapse" } });
			//config rows
			const allConfigRows = Object.entries(this.config.MultiFeatureConfiguration).filter(kvp => kvp[1].FeatureType == "UnlockRows") as [string, UnlockRowsConfig][];
			assertNotMore(1, allConfigRows.length, "Expected at most 1 UnlockRows configuration");

			let configRows = allConfigRows[0][1];
			let unlockRows = spin.SpinWithFeatures.FeatureResults["UnlockRows"] as UnlockRowsResult;

			for (let i = 0; i < playWindow.Height; i++) {
				let tr: HTMLElement = CreateElement("tr", { classes: ["tr"], parentToAppend: reelTable , style : { justifyContent : "center", alignItems : "center" }});
				
				if (unlockRows != null &&
					i < unlockRows.Rows.length &&
					unlockRows.CountTotal < unlockRows.Rows[i].Unlock)
				{
					// locked
					SetStyles(tr, {
						border: "5px solid red",
						backgroundColor: "rgba(255, 0, 0, 0.2)",
					});
				}

				for (let j = 0; j < playWindow.Width; j++) {

					let coulmnWidth: number = 100 / playWindow.Width;
					let rowHeigt: number = 100 / playWindow.Height;
					let reel = reelSet.find((r) => r.Row == i && r.Col == j);
					if (reel == null) {

					}
					else {
						let td: HTMLTableDataCellElement = CreateElement("td", {
							classes: ["td"], parentToAppend: tr,
							style: {
								//border:"5px solid blue",
								fontSize: Scale.fhpx(80),
								width: "" + (coulmnWidth * reel.ColSpan) + "%",
								height: "" + (rowHeigt * reel.RowSpan) + "%",
								textAlign: "center",
								//display : "flex",
								//justifyContent : "center",
								//alignItems : "center",
								//margin : "auto" , 
								//padding : "auto"
							}
						});
						td.colSpan = reel.ColSpan;
						td.rowSpan = reel.RowSpan;

						// TODO what if the action is start action?
						// should just skip it...




						let scatterPosition: AwardOptionPosition = (spin.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult).ScattersPosition.find(s => j == s.Col && i == s.Row);
						//let scatterPosition: AwardOptionPosition =(spin.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult).ScattersPosition.find(s => j == s.Col && i == s.Row);

						console.log(`Checking col ${j} row ${i}: `, scatterPosition);

						let sizeSymbol = new Size(Scale.W((coulmnWidth * reel.ColSpan) * 6), Scale.H((rowHeigt * reel.RowSpan) * 4))

						if (scatterPosition) {

							let containerSymbolScatter = CreateElement("div", {
								parentToAppend : td,
								style: {
									display : "flex",
									justifyContent : "center",
									alignContent : "center",
									alignItems : "center" , 
									width : "100%",
									height : "100%",									
								}
							})



							let symbol = this.params.symbolCollection.symbolCollectionMap.get("Symbol_"+spin.SpinWithFeatures.ExpectedSymbols[j][i]).imgResource.cloneNode() as HTMLElement;
							symbol.style.position = "absolute";
							//symbol.style.display = "flex";
							symbol.style.width = sizeSymbol.Width + "px";
							symbol.style.height = "auto";
							containerSymbolScatter.appendChild(symbol);	
							
							

							let textHTML = CreateElement("div",{
								style : {
									fontSize :  Scale.fhpx(20),
									textAlign: "center",
									justifyContent: "center",
									fontFamily: "NotoSansDisplay-Bold",
									alignContent: "center",
									zIndex : ZIndex.BonusWin + "",
									color : "white",
									textShadow : `${Scale.fhpx(1)} ${Scale.fhpx(1)}  ${Scale.fhpx(1)} black , ${Scale.fhpx(2)} ${Scale.fhpx(2)}  ${Scale.fhpx(2)} black  `,										
								}
							});

							this.scatterRandomAwardFeature?.GetHistoryValue({
								bet: gameState.Bet.Bet,
								scatterPosition: scatterPosition,
								parentElement: textHTML,
								multiplier: bonusMultiplier
							});

							containerSymbolScatter.appendChild(textHTML);

						}
						else {							
							let symbol = this.params.symbolCollection.symbolCollectionMap.get("Symbol_"+spin.SpinWithFeatures.ExpectedSymbols[j][i]).imgResource.cloneNode() as HTMLElement;
							//symbol.style.display = "flex";
							symbol.style.width = sizeSymbol.Width + "px";
							symbol.style.height = "auto";
							symbol.style.filter = "grayscale(100%)";
							td.appendChild(symbol);
						}
					}
				}
			}
		}
		else if (spin.Phase == "End") {
			let endAction = gameState.Actions[actionIndex] as ExtendedSpinAndHoldEndAction;
			gameView.style.flexDirection = "column";
			let titleBonusWin: HTMLElement = CreateElement("div", {
				classes: ["titleBonusWin"], parentToAppend: gameView,
				style:
				{
					width: "100%",
					height: Scale.Hpx(300),
					backgroundRepeat: "no-repeat",
					backgroundSize: "cover",
					backgroundPosition: "center",
					display: "flex",
					flexDirection: "row",
					justifyContent: "center",
					alignItems: "center",
					fontSize: Scale.fhpx(100),
					color: "white",
					textShadow: `${Scale.XY(10)}px ${Scale.XY(10)}px ${Scale.XY(10)}px black, 0px 0px ${Scale.XY(20)}px black, 0px 0px ${Scale.XY(30)}px black`,

				}
			});
			titleBonusWin.innerText = " Bonus Win";

			let winView: HTMLElement = CreateElement("div", {
				classes: ["winView"], parentToAppend: gameView,
				style:
				{
					width: "80%",
					height: Scale.Hpx(180),
					backgroundRepeat: "no-repeat",
					backgroundSize: "cover",
					backgroundPosition: "center",
					display: "flex",
					flexDirection: "row",
					justifyContent: "center",
					alignItems: "center",
					backgroundColor: "rgba(0,0,0,0.5)",
					fontSize: Scale.fhpx(100),
					color: "white",
					textShadow: `0px 0px ${Scale.XY(10)}px black, 0px 0px ${Scale.XY(20)}px black, 0px 0px ${Scale.XY(30)}px black`,
					borderWidth: Scale.XYpx(5),
					borderStyle: "solid",
					filter: `blur(${Scale.XYpx(2)})`,
					backgroundImage: "linear-gradient(rgb(0, 0, 0), rgb(22, 22, 206),rgb(0, 0, 0)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
				}
			});
			winView.innerText = service.moneyFormatter.FormatCurrency(endAction.WinSinceGameStart.TotalWin.InCents)
		}
		return bonusView;
	}

	protected override RequestStopsCommetShowWin() {		
		this.commetView.StopsCommets()
		//this.audio.Stop(this.resid.ScopedResourceName("cometExtended"));		
		this.commetView.StopCometSound();
		//this.timeoutNextCommetCash.Stop();	

		if (this.currentScatterCometIndex >= this.scatterPositions.length)
		{
			Log.Error(this.logGroup, "currentScatterCometIndex is greater than scatterPositions length, shold not exceeed it every");
			;
			return;	
		}

		if ((this.scatterPositions[this.currentScatterCometIndex].AwardOptionPosition.Row >= this.spinnableReels2.GetWindowSymbolSize().Height / 2) && this.isWinContainerShowWinMovedJumped == false && Settings.Screens == 2) {
			//this.animBottomToTopWinContainer.pause();	
			//this.winContainer.style.transform = "translate(0px, 0px)";			
			this.bonusGameAwardViewPIXIAPP.position.y = Scale.Y(-58);
			if(Settings.Enable2plus1 == true )this.bonusGameAwardViewPIXIAPP.position.y = Scale.Y(1085);
			this.isWinContainerShowWinMovedJumped = true;
		}
	}

	protected override async CometsPrepare(resourceManager: IWriteOnlyResourceManager): Promise<void>
	{
		this.commetView = this.commetFactory.CreateCometPIXIAPP(this.audio , this.resid,true,this.params.FpsFactor);
		await this.commetView.PrepareResources(resourceManager);
	}

	protected infoRemainingSpinsTextPIXIAPP : PIXI.Text = null;
	protected unclokFeatureViewPIXAPP : PIXI.Container = null;
	protected override CreateContainersPIXIAPPScreen1(){
		super.CreateContainersPIXIAPPScreen1();
		this.unclokFeatureViewPIXAPP = this.unlockFeature.CreatePIXIAPP(this.spinnableReels2.GetWindowRect(), this.spinnableReels2.GetSymbolSize());
		this.containerBonusViewApp.addChild(this.unclokFeatureViewPIXAPP);
		this.unclokFeatureViewPIXAPP.parent.setChildIndex(this.holdingFeature.ViewPIXIAPP(),3);
		this.unclokFeatureViewPIXAPP.parent.setChildIndex(this.unclokFeatureViewPIXAPP,4);
		this.unclokFeatureViewPIXAPP.parent.setChildIndex(this.commetView.ViewPIXIAPP(),5);
	}
	protected override CreateContainersPIXIAPPScreen2(){
	
		let containerViewScreen2 = new PIXI.Container();		
		containerViewScreen2.name = "containerViewScreen2PIXIAPP";
		this.containerBonusViewApp.addChild(containerViewScreen2);
		this.CreateAwarViewPIXIAPP(containerViewScreen2);

		this.infoRemainingSpinsTextPIXIAPP = new PIXI.Text('',{
            fontFamily: 'NotoSansDisplay-Bold',			
			fontSize: Scale.fh(120),			
			fontWeight: 'bold',
			fill: ["#F2E416", "#F2BE22" , "#C2760E" , "#F2BE22", "#F2E416" ], // gradient
			stroke: 'black',
			strokeThickness: Scale.fh(10),			
			//wordWrap: true,			
			lineJoin: 'round',
			//textBaseline : "middle",			
        })

		containerViewScreen2.addChild(this.infoRemainingSpinsTextPIXIAPP);
		this.infoRemainingSpinsTextPIXIAPP.anchor.set(0.5);
		let yPosition = Settings.ScreenHeight + Scale.H(79)
		if (Settings.Screens != 3) yPosition = Scale.Y(74.5);
		this.infoRemainingSpinsTextPIXIAPP.position.set(Settings.ScreenWidth/2, yPosition);		


		this.translator.SetOnLanguageChangedCallback(() => {
			this.ChangeStateCanvas(this.gameState, this.session.RunsRemaining);
		});

	}

	public override GameExit(){
		super.GameExit();
		//Safe(()=>{this.containerBonusViewApp.destroy({children:true})});	
		Safe(()=>{this.unclokFeatureViewPIXAPP.destroy({children: true, texture: false, baseTexture: true})});
		if (globalThis.jackpotDisplayGlobal != null) {
			TweenLite.to(globalThis.jackpotDisplayGlobal.View(), 2.5, {
				alpha: 1
			});
		}	
		
	}

	// protected override async PrepareSpineResources(resourceManager: IWriteOnlyResourceManager) {
	// 	let bonusResorucesSpine: string = `${Settings.ResourcesFolder}multigame/slot/common/resources/BonusResorucesSpine`;
	// 	//Title Prepare 				
	// 	resourceManager.AddGlobal(new JSONResource(`${bonusResorucesSpine}/TitleBonusStickySpin/TitleBonusStickySpin.json`, ResourceIdentifier.Global.ScopedResourceName(`TitleBonusStickySpinSpineJson`)));
	// 	resourceManager.AddGlobal(new AtlasResource(`${bonusResorucesSpine}/TitleBonusStickySpin/TitleBonusStickySpin.atlas`, ResourceIdentifier.Global.ScopedResourceName(`TitleBonusStickySpinSpineATLAS`)));

	// 	//SpinRemaniningPrepare 
	// 	resourceManager.AddGlobal(new JSONResource(`${bonusResorucesSpine}/SpinsRemaining/SpinsRemaining.json`, ResourceIdentifier.Global.ScopedResourceName(`SpinsRemainingSpineJson`)));
	// 	resourceManager.AddGlobal(new AtlasResource(`${bonusResorucesSpine}/SpinsRemaining/SpinsRemaining.atlas`, ResourceIdentifier.Global.ScopedResourceName(`SpinsRemainingSpineATLAS`)));

	// 	//winAwardFrame Prepare
	// 	let pathWinAwardBonusJSON = `${bonusResorucesSpine}/WinAwardBonus/WinAwardBonus.json`;
	// 	let pathWinAwardBonusATLAS = `${bonusResorucesSpine}/WinAwardBonus/WinAwardBonus.atlas`;
	// 	if (Settings.JackpotDisplayType == JackpotDisplayType.RainbowGirls) {
	// 		pathWinAwardBonusJSON = `${bonusResorucesSpine}/WinAwardBonusStyleJackpot/WinAwardBonusStyleJackpot.json`;
	// 		pathWinAwardBonusATLAS = `${bonusResorucesSpine}/WinAwardBonusStyleJackpot/WinAwardBonusStyleJackpot.atlas`;
	// 	}
	// 	//SpinRemaniningPrepare 
	// 	resourceManager.AddGlobal(new JSONResource(pathWinAwardBonusJSON, ResourceIdentifier.Global.ScopedResourceName(`WinAwardBonusSpineJson`)));
	// 	resourceManager.AddGlobal(new AtlasResource(pathWinAwardBonusATLAS, ResourceIdentifier.Global.ScopedResourceName(`WinAwardBonusSpineATLAS`)));


	// 	//BonusTitlePrepare 
	// 	resourceManager.AddGlobal(new JSONResource(`${bonusResorucesSpine}/BonusWinTitle/BonusWinTitle.json`, ResourceIdentifier.Global.ScopedResourceName(`BonusWinTitleJson`)));
	// 	resourceManager.AddGlobal(new AtlasResource(`${bonusResorucesSpine}/BonusWinTitle/BonusWinTitle.json`, ResourceIdentifier.Global.ScopedResourceName(`BonusWinTitleATLAS`)));

	// 	//SpinRemaniningPrepare 
	// 	resourceManager.AddGlobal(new JSONResource(`${bonusResorucesSpine}/WinCount/WinCount.json`, ResourceIdentifier.Global.ScopedResourceName(`WinCountSpineJson`)));
	// 	resourceManager.AddGlobal(new AtlasResource(`${bonusResorucesSpine}/WinCount/WinCount.atlas`, ResourceIdentifier.Global.ScopedResourceName(`WinCountSpineATLAS`)));
	// 	await this.jackpotSharedShow?.PrepareResources(resourceManager);

	// 	//create award show 
	// 	await this.awardJPShowPIXAPP.PrepareResources(resourceManager);
	// }

	public override GameSelected(app: PIXI.Container) {		
		super.GameSelected(app);
		this.bonusMultiplier?.SetScale(0.4,0.4);
		this.bonusMultiplier?.View().position.set(Scale.X(-130), Scale.Y(832.5));	
		
		if (Settings.Screens == 2)
		{
			this.bonusMultiplier?.View().position.set(Scale.X(-150), Scale.Y(-229));	
		}
	}
}
